import React from 'react';
import { Container } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="footer-hyper">
      <Container>
        <p>© 2025 Arrank • Todos los derechos reservados | powered by <img src="/escudo_texto.png" style={{ height: '40px' }} alt="" /></p>
      </Container>
    </footer>
  );
};

export default Footer;
